import { inject, Injectable, signal } from '@angular/core';
import { Router } from '@angular/router';
import { RaxBFF } from '@raxapp/booker-backend-apis/bff-api-clients/booker.planner.bff.api';

@Injectable({
    providedIn: 'root',
})
export class ShowErrorPageService {
    private router = inject(Router);

    public exceptionView = signal<RaxBFF.Result | undefined>(undefined);

    public show(): void {
        this.router.navigateByUrl('error');
    }
}
